import Vue from 'vue';
import Router from 'vue-router';

const Layout = () => import('./views/Layout.vue');
const Home = () => import('./views/Home.vue');
const AddLead = () => import('./views/AddLead.vue');

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  base: '/affiliates/',
  routes: [
    {
      path: '/:id',
      component: Layout,
      meta: {
        title: 'Affiliate Portal',
      },
      children: [
        {
          path: '',
          redirect: 'home',
        },
        {
          path: 'home',
          component: Home,
        },
        {
          path: 'add',
          component: AddLead,
        },
      ],
    },
  ],
});
